import styled, { keyframes } from 'styled-components'

import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

const shimmer = keyframes`
  100% {
    left: 100%;
  }
`

const SkeletonBox = styled.div`
  width: 100%;
  height: 50px;
  border-radius: 6px;
  background: ${toCSSValue('color-background-tertiary')};
  position: relative;
  overflow: hidden;
`

const Shimmer = styled.div`
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    ${toCSSValue('color-background-primary', 0.6)},
    transparent
  );
  animation: ${shimmer} 2s infinite;
`

export function RectangleSkeleton() {
  return (
    <SkeletonBox>
      <Shimmer />
    </SkeletonBox>
  )
}
